
import React, { useState, useEffect } from "react";
import { Box, TextField, Button, MenuItem, IconButton } from "@mui/material";
import axios from "axios";
import {toast } from "react-toastify";
import { Add, Delete } from "@mui/icons-material";
import { BACKEND_BASE_URL } from "../../config";

const API_BASE_URL = `${BACKEND_BASE_URL}/api`

const featureTypes = [
  { value: "explain", label: "Explain Credits" },
  { value: "ask", label: "Ask Aware Credits" },
];

const AddonForm = ({ addonData, onSuccess, onCancel }) => {
  const [form, setForm] = useState({
    name: addonData?.name || "",
    feature_type: addonData?.feature_type || "explain",
    credits: addonData?.credits || "",
   prices: addonData?.prices || [{ currency: "", price: "", paddle_price_id: "" }],
  });

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const token = localStorage.getItem("authToken");

  // ✅ Fetch currency list from backend  
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/plan-types/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setCurrencyOptions(res.data.currencies || []);
      })
      .catch((err) => {
        console.error("Error fetching currencies:", err);
      });
  }, [token]);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePriceChange = (index, field, value) => {
    const updatedPrices = [...form.prices];
    updatedPrices[index][field] = value;
    setForm({ ...form, prices: updatedPrices });
  };

  const handleAddPrice = () => {
    setForm({
      ...form,
      prices: [...form.prices, { currency: "", price: "" }],
    });
  };

  const handleRemovePrice = (index) => {
    const updatedPrices = form.prices.filter((_, i) => i !== index);
    setForm({ ...form, prices: updatedPrices });
  };
  
  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        prices: form.prices.filter((p) => p.currency && p.price), // remove empty rows
      };

      if (addonData?.id) {
        await axios.put(`${API_BASE_URL}/addons/${addonData.id}/`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Add-on updated successfully!");
      } else {
        await axios.post(`${API_BASE_URL}/addons/create/`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Add-on created successfully!");
      }
      onSuccess();
    } catch (error) {
      console.error("Error saving add-on:", error);
      toast.error("Failed to save add-on.");
    }
  };

  return (
    <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
      <TextField
        label="Add-on Name"
        name="name"
        value={form.name}
        onChange={handleChange}
        fullWidth
      />

      <TextField
        label="Feature Type"
        name="feature_type"
        select
        value={form.feature_type}
        onChange={handleChange}
        fullWidth
      >
        {featureTypes.map((ft) => (
          <MenuItem key={ft.value} value={ft.value}>
            {ft.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Credits"
        name="credits"
        type="number"
        value={form.credits}
        onChange={handleChange}
        fullWidth
      />

       {/* Multiple prices section */}
      <Box>
        <strong>Prices:</strong>
        {form.prices.map((priceObj, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              mt: 1,
            }}
          >
            <TextField
              label="Currency"
              name="currency"
              select
              value={priceObj.currency}
              onChange={(e) =>
                handlePriceChange(index, "currency", e.target.value)
              }
              sx={{ flex: 1 }}
            >
              {currencyOptions.map((cur) => (
                <MenuItem key={cur.value} value={cur.value}>
                  {cur.label || cur.value}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Price"
              type="number"
              value={priceObj.price}
              onChange={(e) =>
                handlePriceChange(index, "price", e.target.value)
              }
              sx={{ flex: 1 }}
            />

            <IconButton
              onClick={() => handleRemovePrice(index)}
              color="error"
              disabled={form.prices.length === 1}
            >
              <Delete />
            </IconButton>
          </Box>
        ))}

        <Button
          startIcon={<Add />}
          onClick={handleAddPrice}
          sx={{ mt: 1 }}
          size="small"
        >
          Add Price
        </Button>
      </Box>

      <Box display="flex" justifyContent="flex-end" gap={1}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          {addonData ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default AddonForm;